// Aerator Project - Controls Seed Data (Prevention & Detection)
// Compatible with DFR-App-Demo

export const controlsSeedData = [
    // PREVENTION CONTROLS
    {
        id: 'C-PREV-001',
        type: 'prevention',
        name: 'Material Spec for ABS High-Impact Resin',
        description: 'Specification requires impact strength >300 J/m (Izod notched)',
        bomIds: [2, 9],
        linkedMaterialSpec: 'MAT-ABS-001',
        implementationDate: '2025-09-15',
        effectiveness: 'High',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['material', 'specification', 'impact']
    },
    {
        id: 'C-PREV-002',
        type: 'prevention',
        name: 'Material Spec for Elastomers (TPE/Viton/NBR)',
        description: 'Compression set requirements and sealing performance specs',
        bomIds: [10, 16, 17],
        linkedMaterialSpec: ['MAT-TPE-001', 'MAT-VITON-001', 'MAT-NBR-001'],
        implementationDate: '2025-10-15',
        effectiveness: 'High',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['elastomer', 'seal', 'gasket']
    },
    {
        id: 'C-PREV-003',
        type: 'prevention',
        name: 'Wire Strain Relief Design',
        description: 'Molded strain relief at wire exit points to prevent flex fatigue',
        bomIds: [12],
        implementationDate: '2025-08-10',
        effectiveness: 'High',
        designFeature: 'Integral strain relief molded into housing',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['wire', 'strain relief', 'fatigue']
    },
    {
        id: 'C-PREV-004',
        type: 'prevention',
        name: 'Corrosion-Resistant Plating on Battery Contacts',
        description: 'Nickel plating (5-10 μm) on all battery contact surfaces',
        bomIds: [4, 5],
        implementationDate: '2025-08-20',
        effectiveness: 'Medium',
        platingSpec: 'Nickel 5-10 μm per ASTM B689',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['plating', 'corrosion', 'battery']
    },
    {
        id: 'C-PREV-005',
        type: 'prevention',
        name: 'Switch Supplier Qualification (100k+ cycles)',
        description: 'Supplier must provide life test data showing >100,000 cycles',
        bomIds: [8],
        supplierQualification: 'ReliableSwitch Corp - Certified',
        implementationDate: '2025-10-25',
        effectiveness: 'High',
        testReport: 'Switch-Life-Test-Report-2025-10.pdf',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['switch', 'supplier', 'qualification']
    },
    {
        id: 'C-PREV-006',
        type: 'prevention',
        name: 'Motor Supplier Qualification (Life Test + Performance)',
        description: 'Brushless motor with ceramic bearings, life tested >200 hours',
        bomIds: [6, 7],
        supplierQualification: 'TurboMotors Ltd - Premium Grade',
        implementationDate: '2025-11-01',
        effectiveness: 'High',
        testReport: 'Motor-Endurance-Test-2025-11.pdf',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['motor', 'brushless', 'bearing']
    },
    {
        id: 'C-PREV-007',
        type: 'prevention',
        name: 'EMC Suppression Components in Motor',
        description: 'Suppression capacitors to reduce electromagnetic interference',
        bomIds: [6],
        implementationDate: '2025-11-01',
        effectiveness: 'Medium',
        complianceStandard: 'FCC Part 15 Class B',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['emc', 'interference', 'motor']
    },
    {
        id: 'C-PREV-008',
        type: 'prevention',
        name: 'Material Spec for 304 Stainless Steel (Food-Safe)',
        description: 'FDA-compliant 304 SS for all food-contact surfaces',
        bomIds: [13, 14],
        linkedMaterialSpec: 'MAT-SS304-001',
        implementationDate: '2025-09-01',
        effectiveness: 'High',
        complianceStandard: 'FDA CFR 177.2750',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['stainless', 'food-safe', 'fda']
    },
    {
        id: 'C-PREV-009',
        type: 'prevention',
        name: 'Press-Fit Assembly Procedure for Motor Shaft Coupling',
        description: 'Controlled press-fit force (500-800N) with inline inspection',
        bomIds: [13],
        implementationDate: '2025-11-10',
        effectiveness: 'High',
        assemblyProcedure: 'WI-ASM-005: Shaft Press-Fit Operation',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['assembly', 'press-fit', 'shaft']
    },
    {
        id: 'C-PREV-010',
        type: 'prevention',
        name: 'Dual Seal Design (Viton Primary + NBR Backup)',
        description: 'Redundant seal design with high-temp primary and backup seal',
        bomIds: [16, 17],
        implementationDate: '2025-10-30',
        effectiveness: 'High',
        designRationale: 'Critical function requires redundancy',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['seal', 'dual', 'redundant']
    },
    {
        id: 'C-PREV-011',
        type: 'prevention',
        name: 'UV-Resistant Adhesive and Ink for Product Label',
        description: 'UV-stabilized materials for outdoor/window exposure',
        bomIds: [20],
        implementationDate: '2025-09-30',
        effectiveness: 'Medium',
        adhesiveSpec: 'UV-resistant acrylic, 180° peel: >5 N/25mm',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['label', 'uv', 'adhesive']
    },

    // DETECTION CONTROLS
    {
        id: 'C-DET-001',
        type: 'detection',
        name: 'Drop Test (1m onto concrete)',
        description: '3-axis drop test to verify structural integrity',
        bomIds: [2],
        testStandard: 'ASTM D5276',
        sampleSize: '3 units per build',
        implementationDate: '2025-09-20',
        effectiveness: 'High',
        acceptanceCriteria: 'No cracks, no functional damage',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['drop', 'test', 'structural']
    },
    {
        id: 'C-DET-002',
        type: 'detection',
        name: 'Go/No-Go Gauge for Critical Dimensions',
        description: 'Fixture gauges for housing fit and alignment checks',
        bomIds: [2, 9],
        implementationDate: '2025-09-25',
        effectiveness: 'High',
        inspectionFrequency: '100% inline inspection',
        gaugeId: 'GAUGE-HSG-001',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['gauge', 'dimension', 'fit']
    },
    {
        id: 'C-DET-003',
        type: 'detection',
        name: 'End-of-Line Electrical Continuity Test',
        description: 'Automated test of complete electrical path @ 100mA',
        bomIds: [3, 8, 12],
        implementationDate: '2025-09-01',
        effectiveness: 'High',
        inspectionFrequency: '100% EOL test',
        testEquipment: 'Auto-Tester-E100',
        acceptanceCriteria: 'Resistance <1Ω, No open circuits',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['electrical', 'continuity', 'eol']
    },
    {
        id: 'C-DET-004',
        type: 'detection',
        name: 'XRF Material Analysis (Incoming Inspection)',
        description: 'X-ray fluorescence to verify material composition',
        bomIds: [4, 5, 13, 14],
        testStandard: 'ASTM E1508',
        implementationDate: '2025-08-15',
        effectiveness: 'High',
        inspectionFrequency: '10% sampling per lot',
        testEquipment: 'Olympus Vanta XRF',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['xrf', 'material', 'composition']
    },
    {
        id: 'C-DET-005',
        type: 'detection',
        name: 'Automated Switch Cycle Test (Sample Validation)',
        description: 'Life cycle testing on switch samples (1000 cycles)',
        bomIds: [8],
        testStandard: 'IEC 61058-1',
        implementationDate: '2025-10-20',
        effectiveness: 'Medium',
        inspectionFrequency: '5 samples per 10,000 units',
        acceptanceCriteria: '>1000 cycles without failure',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['switch', 'cycle', 'life']
    },
    {
        id: 'C-DET-006',
        type: 'detection',
        name: 'IPX4 Splash Resistance Test',
        description: 'Water spray test per IPX4 standard',
        bomIds: [10, 16, 17],
        testStandard: 'IEC 60529 IPX4',
        implementationDate: '2025-10-28',
        effectiveness: 'High',
        inspectionFrequency: '3 units per build validation',
        testDuration: '5 minutes per axis',
        acceptanceCriteria: 'No water ingress to electrical compartment',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['ipx4', 'splash', 'water']
    },
    {
        id: 'C-DET-007',
        type: 'detection',
        name: 'Motor Stall Current and Speed Measurement',
        description: 'Measure no-load and stall current, verify RPM',
        bomIds: [6],
        implementationDate: '2025-11-05',
        effectiveness: 'High',
        inspectionFrequency: '100% EOL test',
        testEquipment: 'Motor-Tester-MT500',
        acceptanceCriteria: 'RPM >14,500, Stall <2.5A, No-load <0.35A',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['motor', 'current', 'speed']
    },
    {
        id: 'C-DET-008',
        type: 'detection',
        name: 'Accelerated Life Test on Motor Samples',
        description: 'ALT: 200 hours continuous operation with loading',
        bomIds: [6, 7],
        testStandard: 'Internal ALT Protocol Rev 3',
        implementationDate: '2025-11-01',
        effectiveness: 'High',
        inspectionFrequency: '10 motors per production batch',
        testConditions: 'Continuous run, simulated load, temp cycling',
        acceptanceCriteria: 'All samples complete 200h without failure',
        verifiedBy: 'WK',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['alt', 'motor', 'endurance']
    },
    {
        id: 'C-DET-009',
        type: 'detection',
        name: 'Visual Inspection of Whisk Geometry',
        description: '100% visual check of whisk coil spacing and symmetry',
        bomIds: [14],
        implementationDate: '2025-11-12',
        effectiveness: 'Medium',
        inspectionFrequency: '100% inspection',
        acceptanceCriteria: 'Coil spacing 8-10mm, No visible deformation',
        verifiedBy: 'JS',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['visual', 'whisk', 'geometry']
    },
    {
        id: 'C-DET-010',
        type: 'detection',
        name: 'Label Adhesion Test (ASTM D3359)',
        description: 'Cross-hatch adhesion test on label samples',
        bomIds: [20],
        testStandard: 'ASTM D3359',
        implementationDate: '2025-09-30',
        effectiveness: 'Medium',
        inspectionFrequency: '5 samples per 5,000 labels',
        acceptanceCriteria: 'Rating 4B or 5B (minimal to no peeling)',
        verifiedBy: 'MC',
        projectName: 'Aerator Pro',
        epochId: 17,
        keywords: ['label', 'adhesion', 'peel']
    }
];

// Control Effectiveness Summary
export const controlEffectiveness = {
    prevention: {
        total: 11,
        highEffectiveness: controlsSeedData.filter(c => c.type === 'prevention' && c.effectiveness === 'High').length,
        mediumEffectiveness: controlsSeedData.filter(c => c.type === 'prevention' && c.effectiveness === 'Medium').length
    },
    detection: {
        total: 10,
        highEffectiveness: controlsSeedData.filter(c => c.type === 'detection' && c.effectiveness === 'High').length,
        mediumEffectiveness: controlsSeedData.filter(c => c.type === 'detection' && c.effectiveness === 'Medium').length,
        eolTests: 3, // End-of-line tests (100% coverage)
        samplingTests: 7 // Batch sampling tests
    },
    totalControls: 21,
    coverageSummary: 'All critical FMEA items have both prevention and detection controls'
};

// Control-to-FMEA Mapping
export const controlToFmeaMapping = {
    'FMEA-001': { prevention: ['C-PREV-001'], detection: ['C-DET-001'] },
    'FMEA-002': { prevention: ['C-PREV-001', 'C-PREV-002'], detection: ['C-DET-002'] },
    'FMEA-003': { prevention: ['C-PREV-003'], detection: ['C-DET-003'] },
    'FMEA-004': { prevention: ['C-PREV-004'], detection: ['C-DET-004'] },
    'FMEA-005': { prevention: ['C-PREV-005'], detection: ['C-DET-005'] },
    'FMEA-006': { prevention: ['C-PREV-005'], detection: ['C-DET-003'] },
    'FMEA-007': { prevention: ['C-PREV-001'], detection: ['C-DET-002'] },
    'FMEA-008': { prevention: ['C-PREV-002'], detection: ['C-DET-006'] },
    'FMEA-009': { prevention: ['C-PREV-006'], detection: ['C-DET-007'] },
    'FMEA-010': { prevention: ['C-PREV-006'], detection: ['C-DET-008'] },
    'FMEA-011': { prevention: ['C-PREV-006', 'C-PREV-007'], detection: ['C-DET-008'] },
    'FMEA-012': { prevention: ['C-PREV-008'], detection: ['C-DET-001'] },
    'FMEA-013': { prevention: ['C-PREV-009'], detection: ['C-DET-002'] },
    'FMEA-014': { prevention: ['C-PREV-008'], detection: ['C-DET-009'] },
    'FMEA-015': { prevention: ['C-PREV-008'], detection: ['C-DET-004'] },
    'FMEA-016': { prevention: ['C-PREV-010'], detection: ['C-DET-006'] },
    'FMEA-020': { prevention: ['C-PREV-011'], detection: ['C-DET-010'] }
};

export const controlsSeedDataInfo = {
    totalControls: controlsSeedData.length,
    preventionControls: controlsSeedData.filter(c => c.type === 'prevention').length,
    detectionControls: controlsSeedData.filter(c => c.type === 'detection').length,
    highEffectivenessControls: controlsSeedData.filter(c => c.effectiveness === 'High').length,
    eolTestCoverage: '100% (Electrical, Motor)',
    criticalControlCount: 8,
    generatedDate: '2025-12-12',
    projectIteration: 17
};
